module.exports = __webpack_public_path__ + "img/icon32.69e77c12.png";